<template>
  <div>
    {{ object.conversion }}%
  </div>
</template>

<script setup>
defineProps({
  object: {
    type: Object
  },
})
</script>
